<template>
  <div class="holiday-closure">
    <table class="holiday-table">
      <thead>
        <tr>
          <th>{{ $t('dialog.body.openinghours.table.title') }}</th>
          <th>{{ $t('dialog.body.openinghours.table.date') }}</th>
          <th>{{ $t('dialog.body.openinghours.table.openinghours') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="day in holidayHours" :key="day.scheduledDate">
          <td>{{ day.notes }}</td>
          <td>{{ day.scheduledDate }}</td>
          <td>
            <span v-if="day.startTime === 'Closed All Day'">
              ❌ {{ $t('dialog.body.openinghours.closedallday') }}
            </span>
            <span v-else>
              🕒 {{ day.startTime }} - {{ day.endTime }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  holidayHours: {
    type: Array,
    required: true
  }
})
</script>

<style scoped>
.holiday-closure {
  text-align: center;
  padding: 20px;
}

.holiday-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.holiday-table th,
.holiday-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.note {
  margin-top: 10px;
  font-style: italic;
}
</style>
